import { render, staticRenderFns } from "./desactivate_stock.vue?vue&type=template&id=4d5076b1&"
import script from "./desactivate_stock.vue?vue&type=script&lang=js&"
export * from "./desactivate_stock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports